export const TOGGLE_ZIP_MENU = 'TOGGLE_ZIP_MENU';

export const toggleZipMenu = () => ({
    type: TOGGLE_ZIP_MENU,
});
